var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 19.5C16.1421 19.5 19.5 16.1421 19.5 12C19.5 7.85786 16.1421 4.5 12 4.5C7.85786 4.5 4.5 7.85786 4.5 12C4.5 16.1421 7.85786 19.5 12 19.5ZM12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z",
    fill: "#6247E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6948 15H10.9679C10.9679 14.5305 11 14.1324 11.0643 13.8057C11.1339 13.474 11.249 13.1754 11.4096 12.91C11.5703 12.6447 11.7871 12.364 12.0602 12.0679C12.2477 11.8485 12.4217 11.6392 12.5823 11.4402C12.7483 11.236 12.8795 11.0242 12.9759 10.8048C13.0776 10.5802 13.1285 10.3199 13.1285 10.0239C13.1285 9.7075 13.0857 9.43955 13 9.2201C12.9143 9.00064 12.7912 8.83477 12.6305 8.72249C12.4699 8.6051 12.2691 8.54641 12.0281 8.54641C11.8461 8.54641 11.6667 8.59745 11.49 8.69952C11.3186 8.79649 11.174 8.94705 11.0562 9.1512C10.9384 9.35534 10.8795 9.62073 10.8795 9.94737H9C9.01071 9.2992 9.14726 8.75566 9.40964 8.31675C9.67738 7.87783 10.0388 7.54864 10.494 7.32919C10.9491 7.10973 11.4605 7 12.0281 7C12.6546 7 13.1874 7.11738 13.6265 7.35215C14.071 7.58182 14.411 7.91866 14.6466 8.36268C14.8822 8.8067 15 9.33748 15 9.95502C15 10.4093 14.917 10.8175 14.751 11.1799C14.585 11.5423 14.3708 11.8817 14.1084 12.1981C13.8514 12.5094 13.581 12.8182 13.2972 13.1244C13.0616 13.3847 12.9036 13.6679 12.8233 13.9742C12.743 14.2753 12.7001 14.6172 12.6948 15Z",
    fill: "#6247E8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 16H12.75V17.5H11.25V16Z",
    fill: "#6247E8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.1f400bb5eb3b51218c4ed7eaf7e59eaa.svg";
export { ForwardRef as ReactComponent };